$(document).ready(function() {
    // Iterate over each carousel on the page
    $('.announcement-carousel').each(function() {
        const $carousel = $(this);
        const $items = $carousel.find('.announcement-carousel-item');
        const $dotsContainer = $carousel.find('.announcement-carousel-dots');
        let currentIndex = 0;
        const totalItems = $items.length;
        const intervalTime = 5000; // Time between slides in milliseconds
        let autoScroll;

        // Create navigation dots for this carousel
        for (let i = 0; i < totalItems; i++) {
            $dotsContainer.append(`<span class="announcement-carousel-dot${i === 0 ? ' active' : ''}" data-index="${i}"></span>`);
        }

        // Show specific item for this carousel
        function showItem(index) {
            $items.removeClass('active').css('opacity', 0);
            $dotsContainer.find('.announcement-carousel-dot').removeClass('active');
            currentIndex = index >= totalItems ? 0 : index < 0 ? totalItems - 1 : index;
            $items.eq(currentIndex).addClass('active').css('opacity', 1);
            $dotsContainer.find('.announcement-carousel-dot').eq(currentIndex).addClass('active');
        }

        // Start or restart auto-scroll for this carousel
        function startAutoScroll() {
            if (autoScroll) {
                clearInterval(autoScroll);
            }
            autoScroll = setInterval(function() {
                showItem(currentIndex + 1);
            }, intervalTime);
        }

        // Dot click handler for this carousel
        $dotsContainer.on('click', '.announcement-carousel-dot', function() {
            const index = parseInt($(this).data('index'));
            if (index !== currentIndex) {
                showItem(index);
                startAutoScroll(); // Restart interval after manual selection
            }
        });

        // Pause on hover for this carousel
        $carousel.on('mouseenter', function() {
            clearInterval(autoScroll);
        }).on('mouseleave', function() {
            startAutoScroll();
        });

        // Initial setup for this carousel
        if (totalItems > 0) {
            showItem(0);
            startAutoScroll();
        }
    });
});
